import { FleetData, IFleetTreeData } from '~/models'

export interface ITree {
  id: string
  name: string
  children?: ITree[]
  relatedEntity: object
  parentId?: string
}

export const fallbackFleetTreeData: IFleetTreeData = {
  name: 'All Fleets',
  fullName: 'All Fleets',
  childrenFleet: [],
  id: '',
  isAccessible: false
}

export function mapIFleetTreeToMuiXTreeView(fleetree: IFleetTreeData): ITree {
  const result: ITree = {
    relatedEntity: fleetree,
    id: fleetree.id,
    name: fleetree.fullName
  }
  if (
    fleetree.childrenFleet &&
    Array.isArray(fleetree.childrenFleet) &&
    fleetree.childrenFleet.length > 0
  ) {
    result.children = []
    for (let child of fleetree.childrenFleet) {
      const mappedChild = mapIFleetTreeToMuiXTreeView(child)
      mappedChild.parentId = result.id
      result.children.push(mappedChild)
    }
  }
  return result
}

export function flattenFleetTreeNameIdPair(fleetree: IFleetTreeData): FleetData[] {
  const result: FleetData[] = []
  result.push({ id: fleetree.id, shortName: fleetree.fullName })
  if (fleetree.childrenFleet) {
    for (let child of fleetree.childrenFleet) {
      const childFlat = flattenFleetTreeNameIdPair(child)
      for (let f of childFlat) {
        result.push(f)
      }
    }
  }
  return result
}

export const TreeHelper = {
  searchTreeBfs: (graph: ITree | undefined | null, targetId: any) => {
    if (graph) {
      const queue = [graph]

      while (queue.length > 0) {
        const currNode = queue.shift()
        if (currNode) {
          if (currNode.id === targetId) {
            return currNode
          }
          if (currNode.children) {
            queue.push(...currNode.children)
          }
        } else {
          return null
        }
      }
    }
    return null // Target node not found
  },

  getAllParents: (tree: ITree, node: ITree, list: ITree[] = []): ITree[] => {
    if (node.parentId) {
      const parent = TreeHelper.searchTreeBfs(tree, node.parentId)
      if (parent) {
        list.push(parent)
        return TreeHelper.getAllParents(tree, parent, list)
      }
    }

    return list
  },

  getAllChildIds: (tree: ITree, nodeId: string): string[] => {
    const x = TreeHelper.searchTreeBfs(tree, nodeId)
    if (x) {
      return TreeHelper.getAllIds(x).filter(c => c !== x.id)
    }
    return []
  },

  getAllChildNodes: (node: ITree): ITree[] => {
    let result: ITree[] = []
    if (node.children) {
      for (const child of node.children) {
        result = result.concat(TreeHelper.getAllChildNodes(child))
      }
    }
    return result
  },

  getAllIds: (node: ITree, idList: string[] = []): string[] => {
    idList.push(node.id)
    if (node.children) {
      node.children.forEach(child => TreeHelper.getAllIds(child, idList))
    }
    return idList
  },

  isAllChildrenChecked: (node: ITree, selectedIds: string[]) => {
    const allChildIds = TreeHelper.getAllIds(node).filter(c => c !== node.id)

    return allChildIds.every(nodeId => selectedIds.includes(nodeId))
  },

  pruneTree: (node: ITree, keepIds: string[]) => {
    if (node.children) {
      const newArr: ITree[] = []
      for (let child of node.children) {
        if (keepIds.indexOf(child.id) !== -1) {
          newArr.push(child)
        }
      }
      node.children = newArr.length > 0 ? newArr : undefined
      if (node.children) {
        for (let child of node.children) {
          TreeHelper.pruneTree(child, keepIds)
        }
      }
    }
  }
}
